/* istanbul ignore file */
import EmployeeLink, { EmployeeLinkProps } from './EmployeeLink';
import useEmployeeNamesService from './employeeNames/employeeNamesService';
import { NameField } from 'framework/ui/field';
import { useAsyncValue } from 'framework/utils';
import { InputLoader } from 'framework/ui/mui-builder';

interface EmployeeLinkWithNameLoadingProps extends Omit<EmployeeLinkProps, 'id' | 'name'> {
  id: string;
  name?: EmployeeLinkProps['name'];
  defaultValue?: string;
  isHandleError?: boolean;
}

const EmployeeLinkWithNameLoading = ({
  id,
  name,
  defaultValue,
  isHandleError = false,
  ...linkProps
}: EmployeeLinkWithNameLoadingProps) => {
  const { getEmployeeNameDataById } = useEmployeeNamesService();

  const employeeName = useAsyncValue(
    () => (id && name == null ? getEmployeeNameDataById(id, isHandleError) : Promise.resolve({})),
    [id, name],
  );

  if (name != null) return <EmployeeLink name={name} id={id} {...linkProps} />;

  return employeeName === null ? (
    <InputLoader />
  ) : (
    <EmployeeLink
      name={employeeName?.nameEn ? <NameField value={employeeName?.nameEn} /> : defaultValue || id}
      id={id}
      {...linkProps}
    />
  );
};

export default EmployeeLinkWithNameLoading;
